export const environment = {
  backendUrl: 'https://test.api.comex-mckinnon.ie',
  googleMaps: {
    apiKey: 'AIzaSyAPLqKJUT1DDmLv525lho9aZbgz6kwKv2c',
    mapId: 'af238500b91e1c498778ae95',
  },
};
